import { BaseFirestoreRepository } from './base-firestore.repository';
import { BaseModel } from './base.model';

export class Sequence extends BaseModel {
  seed: number;
  next: number;

  constructor(id: string, seed = 1) {
    super(id);
    this.seed = seed;
    this.next = seed;
  }
}

export class SequenceRepository extends BaseFirestoreRepository<Sequence> {
  constructor() {
    super('main_sequences');
  }

  async next<T>(id: string, seed: number) {
    let sequence = await this.getById(id);
    if (sequence) {
      sequence.next += 1;
      await this.update(id, sequence);
    }
    if (!sequence) {
      sequence = new Sequence(id, seed);
      this.add(sequence);
    }
    return sequence.next as T;
  }
}
